import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'

import Axios from '@components/Axios'
import Icon from '@components/Icon'
import Table from '@components/Table'

import './styles.scss'

const PostList = ({ list = [], setItem, updateList }) => {
  const columns = [
    {
      title: 'POST_LIST_BANNER',
      component: ({ banner }) => {
        return <img alt="BANNER" className="item-banner" src={banner} />
      }
    },
    { title: 'POST_LIST_TITLE', field: 'title' },
    { title: 'POST_LIST_AUTHOR', field: 'author' },
    { title: 'POST_LIST_PUBLISH',
      component: item => {
        let status = item.status === 'PUBLISHED' ? 'Publicado' : 'Rascunho'
        return (
          <>
            {status}
          </>
        )
      }
    },
    {
      title: 'POST_LIST_OPTIONS',
      className: 'options',
      component: item => {
        return (
          <>
            <IconButton onClick={() => setItem(item)} className="list-edit">
              <Icon size={30} name="edit" />
            </IconButton>
            <Axios
              api="posts"
              method="delete"
              others={item._id}
              onSuccess={updateList}
            >
              {({ submit }) => (
                <IconButton onClick={submit} className="list-delete">
                  <Icon size={30} name="delete_icon" />
                </IconButton>
              )}
            </Axios>
          </>
        )
      }
    }
  ]

  return (
    <div className="PostList">
        
      <Table data={list} columns={columns} title="POST_LIST_TABLE_TITLE" />
           
    </div>
  )
}

export default PostList

PostList.propTypes = {
  list: PropTypes.array,
  setItem: PropTypes.func,
  updateList: PropTypes.func
}
